import type { ReactNode } from "react";
import { lazy, Suspense } from "react";

// Gate on the literal env value (not the runtime `isProviderEnabled` helper)
// so Vite constant-folds the check at build time and tree-shakes the
// `StatsigProvider` chunk + `vendor-statsig` SDK out of non-Statsig builds.
const clientKey = import.meta.env.VITE_STATSIG_CLIENT_KEY;
const isStatsigAvailable = import.meta.env.VITE_ANALYTICS_TOOL === "statsig" && !!clientKey;

const LazyAppStatsigProvider = isStatsigAvailable
  ? lazy(() => import("./StatsigProvider").then((m) => ({ default: m.AppStatsigProvider })))
  : null;

export function StatsigPreloadProvider({ children }: { children: ReactNode }) {
  if (!isStatsigAvailable || !LazyAppStatsigProvider) {
    return children;
  }

  return (
    <Suspense fallback={null}>
      <LazyAppStatsigProvider>{children}</LazyAppStatsigProvider>
    </Suspense>
  );
}
